export class Constants {
    static KEY_DEFAULT_LANGUAGE = 'hungerztc_dl';
    static KEY_DARK_MODE = 'hungerztc_dark_mode';
    static KEY_IS_DEMO_MODE = 'hungerztc_is_demo_mode';

    static THEME_MODE_DARK = "theme_dark";
    static THEME_MODE_LIGHT = "theme_light";

}